module.exports = __webpack_public_path__ + "img/team-norderstedt@2x.a4e5fafe.jpg";